<script lang="ts">
  import { format, strings } from '../../strings';
  import Dialog from '../../ui/Dialog.svelte';

  let { open = $bindable(false) }: { open?: boolean } = $props();

  const links = [
    { href: 'https://git.hanna.lol/kinklist', label: strings.aboutSource },
    { href: 'https://github.com/Goctionni/kinklist-v2', label: strings.aboutOriginal },
  ];
</script>

<Dialog bind:open title={strings.aboutTitle} description={strings.aboutSummary}>
  <div class="flex flex-col gap-4 text-sm">
    <section class="flex flex-col gap-1">
      <h3 class="font-semibold">{strings.aboutPrivacyTitle}</h3>
      <p class="text-ink-muted">{strings.aboutPrivacy}</p>
    </section>
    <section class="flex flex-col gap-1">
      <h3 class="font-semibold">{strings.aboutCreditsTitle}</h3>
      <p class="text-ink-muted">{strings.aboutCredits}</p>
      <ul class="flex flex-wrap gap-x-4 gap-y-1">
        {#each links as link (link.href)}
          <li>
            <a
              class="font-medium text-accent underline underline-offset-2 hover:no-underline"
              href={link.href}
              target="_blank"
              rel="noopener noreferrer">{link.label}</a
            >
          </li>
        {/each}
      </ul>
    </section>
    <p class="text-xs text-ink-muted">
      {format.version(__APP_VERSION__)} · {strings.aboutLicense}
    </p>
  </div>
</Dialog>
